import request from '@/utils/axios';

import { getSearchItemsByCount } from '../../utils';
import {
  LOAD_SEARCH_RESULTS_BEGIN,
  LOAD_SEARCH_RESULTS_ERROR,
  LOAD_SEARCH_RESULTS_SUCCESS,
} from '../types/searchResultsTypes';

function loadSearchResultsBegin() {
  return {
    type: LOAD_SEARCH_RESULTS_BEGIN,
    payload: {
      isLoadingResults: true,
      lastLoadSearchId: null,
    },
  };
}

function loadSearchResultsError() {
  return {
    type: LOAD_SEARCH_RESULTS_ERROR,
    payload: {
      isLoadingResults: false,
    },
  };
}

function loadSearchResultsSuccess(results, count, searchItems) {
  return {
    type: LOAD_SEARCH_RESULTS_SUCCESS,
    payload: {
      isLoadingResults: false,
      results,
      count,
      searchItems,
    },
  };
}

export const resetResults = () => {
  return async dispatch => {
    dispatch(loadSearchResultsSuccess([], 0));
  };
};

export const fetchSearchResults = payload => {
  return async dispatch => {
    try {
      dispatch(loadSearchResultsBegin());
      /** @type {import("axios").AxiosResponse<import("@/src/types/swagger").ISearchDTO>} */
      await request({
        method: 'POST',
        url: '/cms/search',
        data: payload,
        triggerLoad: false,
        baseURL: process.env.V2_API_ROOT,
      })
        .then((response) => {
          const { data } = response;
          const { results, count } = data;
          if (!count) {
            dispatch(loadSearchResultsSuccess([], 0));
          } else if (count && count > 0) {
            const activeSearchItems = getSearchItemsByCount(payload, count);
            dispatch(loadSearchResultsSuccess(results, count, activeSearchItems));
          } else {
            dispatch(loadSearchResultsError([], 0));
          }
        })
        .catch(err => {
          console.warn(err);
          dispatch(loadSearchResultsError([], 0));
        });
    } catch (err) {
      console.warn(err);
      dispatch(loadSearchResultsError([], 0));
    }
  };
};
